
import { defineComponent } from 'vue'
import AlertIcon from '@/components/vectors/AlertIcon.vue'

export default defineComponent({
  props: { message: String },
  components: { AlertIcon }
})
